import React from 'react';
import { useState } from 'react'; 
import Table from '../../components/Table';
import YearGrid from '../../components/YearGrid';
import './index.css';
import mp from '../../shared/PublicationData';

export default function Publication() {

  const [year, setYear] = useState(2023);


  const handleYearChange = (value)=>{
    setYear(value);
  }


//////////////////////////////////////////////////////////////////////////
///////////// Please update the Map for every year////////////////////////
//////////////////////////////////////////////////////////////////////////


  const config = [
 
    {
      label: 'Content',
      render: (element)=>{
        return(
          <div>
            <div>{element.paperNo}.{element.title}</div>
            <div>({element.collaborator})</div>
            <div><a href={`${element.link}`} style={{textDecoration: "underline",color: "blue"}}>{element.linkTitle}</a></div>
          </div>
        )
      }
    },
    {
      label: 'Overview',
      render: (element)=><img src={element.overview} alt={element.title} height = "350" width = "450"/>
    },

  ];

  const keyFn = (element)=>{
    return element.title;
  }

  return (
    <>
      <YearGrid value = {year} onSelect = {handleYearChange}/>
      <div>
        <Table data = {mp.get(year)} config = {config} value = {year} keyFn = {keyFn}/>
      </div>
      
    </>
  )
}



